<p-dialog [modal]="true" [(visible)]="visible" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="headless">
        <div class="p-0 flex flex-col bg-[#FFFFFF] rounded-[16px] font-[Gilroy] mobile:overflow-y-auto"
            *ngIf="!successful">
            <div class="flex w-full justify-between items-center p-4">
                <p class="text-primary font-semibold text-lg">
                    {{ 'invoice.edit_electricity' | transloco }}
                </p>
            </div>

            <div class="flex py-4">
                <div class="h-[2px] bg-primary w-full"></div>
            </div>

            <p class="px-6">{{ 'admin.numer_of_pods' | transloco }}</p>
            <div class="flex w-full justify-between gap-5 mobile:flex-col mobile:justify-normal mobile:items-center">
                <div class="flex items-center space-x-4 p-6 mobile:p-2">
                    <button type="button" (click)="changePodCount(-1)"
                        class="px-4 py-2 border rounded-[16px] hover:bg-primary-300">-</button>
                    <span>{{ numberOfPods }}</span>
                    <button type="button" (click)="changePodCount(1)"
                        class="px-4 py-2 border rounded-[16px] hover:bg-primary-300">+</button>
                </div>

                <div class="h-[45px] w-[300px] px-6 mobile:p-2">
                    <app-custom-button buttonText="{{ 'admin.reset' | transloco }}" (buttonClick)="resetDialogData()"
                        backgroundColor="bg-error-300" textColor="text-neutral" borderColor="border-neutral"
                        hoverBackgroundColor="hover:bg-error-800" hoverTextColor="hover:text-black"
                        hoverBorderColor="hover:border-neutral">
                    </app-custom-button>
                </div>
            </div>


            <div class="flex flex-col gap-4 px-6 overflow-y-auto max-h-[60vh] mobile:max-h-[50dvh]">
                <div class="flex gap-2 flex-wrap items-end">
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]" labelText="ID"
                            [inputId]="'invoiceNumber'" [inputType]="'text'" [(inputValue)]="invoiceIdInput"
                            [errorMessage]="invoiceIdError" placeholder="ID">
                        </app-labeled-input>
                    </div>

                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'archive.overview.file_name' | transloco }}" [inputId]="'invoiceNumber'"
                            [inputType]="'text'" [(inputValue)]="invoiceFileNameInput" [errorMessage]="invoiceIdError"
                            placeholder="{{ 'archive.overview.file_name' | transloco }}">
                        </app-labeled-input>
                    </div>
                </div>

                <!-- Location -->
                <div class="flex gap-2 flex-wrap items-end">
                    <!-- Street -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'shared.labels.street' | transloco }}" [inputId]="'street'"
                            [inputType]="'text'" [(inputValue)]="streetInput" [errorMessage]="streetInputError"
                            placeholder="{{ 'shared.placeholders.street' | transloco }}">
                        </app-labeled-input>
                    </div>

                    <!-- Number -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'shared.labels.street_number' | transloco }}" [inputId]="'number'"
                            [inputType]="'text'" [(inputValue)]="numberInput" [errorMessage]="numberInputError"
                            placeholder="{{ 'shared.placeholders.street_number' | transloco }}">
                        </app-labeled-input>
                    </div>

                    <!-- Postal Code -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'shared.labels.postal_code' | transloco }}" [inputId]="'postalCode'"
                            [inputType]="'text'" [(inputValue)]="postalCodeInput" [errorMessage]="postalCodeInputError"
                            placeholder="{{ 'shared.placeholders.postal_code' | transloco }}">
                        </app-labeled-input>
                    </div>

                    <!-- City -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'shared.labels.city' | transloco }}" [inputId]="'city'" [inputType]="'text'"
                            [(inputValue)]="cityInput" [errorMessage]="cityInputError"
                            placeholder="{{ 'shared.placeholders.city' | transloco }}">
                        </app-labeled-input>
                    </div>

                    <!-- Province -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'shared.labels.province' | transloco }}" [inputId]="'province'"
                            [inputType]="'text'" [(inputValue)]="provinceInput" [errorMessage]="provinceInputError"
                            placeholder="{{ 'shared.placeholders.province' | transloco }}">
                        </app-labeled-input>
                    </div>

                    <!-- Latitude -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'shared.labels.coordinates.lat' | transloco }}" [inputId]="'latitude'"
                            [inputType]="'text'" [(inputValue)]="latitudeInput" [errorMessage]="latitudeInputError"
                            placeholder="{{ 'shared.labels.coordinates.lat' | transloco }}">
                        </app-custom-number-input>
                    </div>

                    <!-- Longitude -->
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'shared.labels.coordinates.long' | transloco }}" [inputId]="'longitude'"
                            [inputType]="'text'" [(inputValue)]="longitudeInput" [errorMessage]="longitudeInputError"
                            placeholder="{{ 'shared.labels.coordinates.long' | transloco }}">
                        </app-custom-number-input>
                    </div>
                </div>

                <!-- Base invoice fields -->
                <div class="flex gap-2 flex-wrap items-end">
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'invoice.labels.number' | transloco }}" [inputId]="'invoiceNumber'"
                            [inputType]="'text'" [(inputValue)]="invoiceNumberInput"
                            [errorMessage]="invoiceNumberInputError"
                            placeholder="{{ 'invoice.placeholders.number' | transloco }}">
                        </app-labeled-input>
                    </div>

                   <div class="w-[300px]">
                        <app-custom-dropdown 
                            [options]="consumptionClassDropdownOptions"
                            label="{{ 'invoice.labels.consumption_class' | transloco }}"
                            [(selectedOption)]="selectedConsumptionClassDropdown" 
                            [disabled]="saveClicked"
                            boxHeight="min-h-[50px] max-h-[70px]"
                            [errorMessage]="invoiceConsumptionClassError">
                        </app-custom-dropdown>
                    </div>

                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-date-input inputId="forPeriod" labelText="{{ 'invoice.labels.period' | transloco }}"
                            placeholder="{{ 'invoice.placeholders.period' | transloco }}" [(dateValue)]="forPeriodDate"
                            [errorMessage]="forPeriodInputError" [isDisabled]="false" dateFormat="mm/yy"
                            boxHeight="min-h-[50px] max-h-[70px]">
                        </app-custom-date-input>
                    </div>
                </div>

                <div class="flex gap-2 flex-wrap items-end">
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'invoice.labels.total_consumption' | transloco }} kWh"
                            [inputId]="'totalConsumption'" [inputType]="'number'" [(inputValue)]="totalConsumptionInput"
                            [errorMessage]="totalConsumptionInputError"
                            placeholder="{{ 'invoice.placeholders.total_consumption' | transloco }}">
                        </app-custom-number-input>
                    </div>

                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'invoice.labels.amount_actual' | transloco }}"
                            [inputId]="'invoiceAmountActual'" [inputType]="'number'"
                            [(inputValue)]="invoiceAmountActualInput" [errorMessage]="invoiceAmountActualInputError"
                            placeholder="{{ 'invoice.placeholders.amount' | transloco }}">
                        </app-custom-number-input>
                    </div>

                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'invoice.labels.amount_gross' | transloco }}" [inputId]="'invoiceAmountGross'"
                            [inputType]="'number'" [(inputValue)]="invoiceAmountGrossInput"
                            [errorMessage]="invoiceAmountGrossInputError"
                            placeholder="{{ 'invoice.placeholders.amount' | transloco }}">
                        </app-custom-number-input>
                    </div>

                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'invoice.labels.total_discount_amount' | transloco }}"
                            [inputId]="'totalDiscount'" [inputType]="'number'" [(inputValue)]="totalDiscountInput"
                            [errorMessage]="totalDiscountInputError">
                        </app-custom-number-input>
                    </div>
                </div>

                <div class="flex gap-2 flex-wrap items-end">
                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'invoice.labels.vat_rate' | transloco }}" [inputId]="'invoiceVatRate'"
                            placeholder="{{ 'invoice.placeholders.enter_as_decimal' | transloco }}" [inputType]="'text'"
                            [(inputValue)]="vatRateInput" [errorMessage]="vatRateInputError">
                        </app-custom-number-input>
                    </div>

                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'invoice.labels.vat_amount' | transloco }}" [inputId]="'invoiceVatAmount'"
                            [inputType]="'text'" [(inputValue)]="vatAmountInput" [errorMessage]="vatAmountInputError">
                        </app-custom-number-input>
                    </div>

                    <div class="flex-[1] self-center min-w-[250px]">
                        <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                            labelText="{{ 'invoice.labels.nontaxable_amount' | transloco }}"
                            [inputId]="'nontaxableAmount'" [inputType]="'number'" [(inputValue)]="nontaxableAmountInput"
                            [errorMessage]="nontaxableAmountInputError">
                        </app-custom-number-input>
                    </div>
                </div>

                <!-- POD data-->
                <div *ngFor="let pod of editedPods; let i = index" class="border border-border rounded-xl p-4 my-6">
                    <p class="text-primary text-lg font-semibold mb-4">
                        {{ 'invoice.sections.pod_number' | transloco }} {{ i + 1 }}
                    </p>
                    <div class="flex gap-2 flex-wrap items-end mt-4">
                        <div class="w-[300px]">
                            <app-custom-dropdown [options]="contractTypeDropdownOptions"
                                label="{{ 'invoice.labels.contract_type' | transloco }}"
                                [(selectedOption)]="editedPods[i].selectedContractTypeDropdown" [disabled]="saveClicked"
                                boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-dropdown>
                        </div>

                        <div class="flex-[1] min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'shared.labels.electricity.pod_id' | transloco }}"
                                [inputId]="'pod_id' + i" [(inputValue)]="editedPods[i].pod_id"
                                placeholder="{{ 'shared.placeholders.electricity.pod_id' | transloco }}">
                            </app-labeled-input>
                        </div>

                        <div class="flex-[1] min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.total_taxes' | transloco }}" [inputId]="'total_taxes' + i"
                                [inputType]="'number'" [(inputValue)]="editedPods[i].total_taxes"
                                placeholder="{{ 'invoice.placeholders.total_taxes' | transloco }}">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.vat_rate' | transloco }}" [inputId]="'vat_rate_' + i"
                                placeholder="{{ 'invoice.placeholders.enter_as_decimal' | transloco }}"
                                [inputType]="'text'" [(inputValue)]="editedPods[i].vat_rate">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.vat_amount' | transloco }}" [inputId]="'vat_amount_' + i"
                                [inputType]="'text'" [(inputValue)]="editedPods[i].vat_amount_actual">
                            </app-custom-number-input>
                        </div>
                    </div>

                    <!-- Location -->
                    <div class="flex gap-2 flex-wrap items-end">
                        <!-- Street -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'shared.labels.street' | transloco }}" [inputId]="'street' + i"
                                [inputType]="'text'" [(inputValue)]="editedPods[i].location.street"
                                placeholder="{{ 'shared.placeholders.street' | transloco }}">
                            </app-labeled-input>
                        </div>

                        <!-- Number -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'shared.labels.street_number' | transloco }}" [inputId]="'number' + i"
                                [inputType]="'text'" [(inputValue)]="editedPods[i].location.number"
                                placeholder="{{ 'shared.placeholders.street_number' | transloco }}">
                            </app-labeled-input>
                        </div>

                        <!-- Postal Code -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'shared.labels.postal_code' | transloco }}" [inputId]="'postalCode' + i"
                                [inputType]="'text'" [(inputValue)]="editedPods[i].location.postal_code"
                                placeholder="{{ 'shared.placeholders.postal_code' | transloco }}">
                            </app-labeled-input>
                        </div>

                        <!-- City -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'shared.labels.city' | transloco }}" [inputId]="'city' + i"
                                [inputType]="'text'" [(inputValue)]="editedPods[i].location.city"
                                placeholder="{{ 'shared.placeholders.city' | transloco }}">
                            </app-labeled-input>
                        </div>

                        <!-- Province -->
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'shared.labels.province' | transloco }}" [inputId]="'province' + i"
                                [inputType]="'text'" [(inputValue)]="editedPods[i].location.province"
                                placeholder="{{ 'shared.placeholders.province' | transloco }}">
                            </app-labeled-input>
                        </div>
                    </div>

                    <p class="text-sm font-semibold text-secondary my-4">
                        F0
                    </p>
                    <!-- Repeat for F0 -->
                    <div class="flex gap-2 flex-wrap items-end mt-4">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.month_consumption_f0' | transloco }}"
                                [inputId]="'month_consumption_f0_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].month_consumption_f0">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.pun_price_f0' | transloco }}"
                                [inputId]="'pun_price_f0_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].pun_price_f0">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.spread_f0' | transloco }}" [inputId]="'spread_f0_' + i"
                                [inputType]="'number'" [(inputValue)]="editedPods[i].spread_f0">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.price_var_f0' | transloco }}"
                                [inputId]="'price_var_f0_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].price_var_f0">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.price_fix_f0' | transloco }}"
                                [inputId]="'price_fix_f0_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].price_fix_f0">
                            </app-custom-number-input>
                        </div>
                    </div>
                    <p class="text-sm font-semibold text-secondary my-4">
                        F1
                    </p>
                    <!-- Month Consumption & Prices for F1 -->
                    <div class="flex gap-2 flex-wrap items-end">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.month_consumption_f1' | transloco }}"
                                [inputId]="'month_consumption_f1_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].month_consumption_f1">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.pun_price_f1' | transloco }}"
                                [inputId]="'pun_price_f1_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].pun_price_f1">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.spread_f1' | transloco }}" [inputId]="'spread_f1_' + i"
                                [inputType]="'number'" [(inputValue)]="editedPods[i].spread_f1">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.price_var_f1' | transloco }}"
                                [inputId]="'price_var_f1_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].price_var_f1">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.price_fix_f1' | transloco }}"
                                [inputId]="'price_fix_f1_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].price_fix_f1">
                            </app-custom-number-input>
                        </div>
                    </div>
                    <p class="text-sm font-semibold text-secondary my-4">
                        F2
                    </p>
                    <!-- F2 -->
                    <div class="flex gap-2 flex-wrap items-end mt-4">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.month_consumption_f2' | transloco }}"
                                [inputId]="'month_consumption_f2_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].month_consumption_f2">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.pun_price_f2' | transloco }}"
                                [inputId]="'pun_price_f2_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].pun_price_f2">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.spread_f2' | transloco }}" [inputId]="'spread_f2_' + i"
                                [inputType]="'number'" [(inputValue)]="editedPods[i].spread_f2">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.price_var_f2' | transloco }}"
                                [inputId]="'price_var_f2_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].price_var_f2">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.price_fix_f2' | transloco }}"
                                [inputId]="'price_fix_f2_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].price_fix_f2">
                            </app-custom-number-input>
                        </div>
                    </div>
                    <p class="text-sm font-semibold text-secondary my-4">
                        F3
                    </p>
                    <!-- F3 -->
                    <div class="flex gap-2 flex-wrap items-end mt-4">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.month_consumption_f3' | transloco }}"
                                [inputId]="'month_consumption_f3_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].month_consumption_f3">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.pun_price_f3' | transloco }}"
                                [inputId]="'pun_price_f3_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].pun_price_f3">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.spread_f3' | transloco }}" [inputId]="'spread_f3_' + i"
                                [inputType]="'number'" [(inputValue)]="editedPods[i].spread_f3">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.price_var_f3' | transloco }}"
                                [inputId]="'price_var_f3_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].price_var_f3">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.price_fix_f3' | transloco }}"
                                [inputId]="'price_fix_f3_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].price_fix_f3">
                            </app-custom-number-input>
                        </div>
                    </div>
                    <p class="text-sm font-semibold text-secondary my-4">
                        P
                    </p>
                    <!-- Repeat for P -->
                    <div class="flex gap-2 flex-wrap items-end mt-4">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.month_consumption_p' | transloco }}"
                                [inputId]="'month_consumption_p_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].month_consumption_p">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.pun_price_p' | transloco }}"
                                [inputId]="'pun_price_p_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].pun_price_p">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.spread_p' | transloco }}" [inputId]="'spread_p_' + i"
                                [inputType]="'number'" [(inputValue)]="editedPods[i].spread_p">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.price_var_p' | transloco }}"
                                [inputId]="'price_var_p_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].price_var_p">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.price_fix_p' | transloco }}"
                                [inputId]="'price_fix_p_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].price_fix_p">
                            </app-custom-number-input>
                        </div>
                    </div>

                    <p class="text-sm font-semibold text-secondary my-4">
                        P0
                    </p>
                    <!-- PO -->
                    <div class="flex gap-2 flex-wrap items-end mt-4">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.month_consumption_po' | transloco }}"
                                [inputId]="'month_consumption_po_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].month_consumption_po">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.pun_price_po' | transloco }}"
                                [inputId]="'pun_price_po_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].pun_price_po">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.spread_po' | transloco }}" [inputId]="'spread_po_' + i"
                                [inputType]="'number'" [(inputValue)]="editedPods[i].spread_po">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.price_var_po' | transloco }}"
                                [inputId]="'price_var_po_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].price_var_po">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.price_fix_po' | transloco }}"
                                [inputId]="'price_fix_po_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].price_fix_po">
                            </app-custom-number-input>
                        </div>
                    </div>

                    <div class="flex gap-2 flex-wrap items-end mt-4">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.tariff_code' | transloco }}"
                                [inputId]="'tariff_code_' + i" [inputType]="'text'"
                                [(inputValue)]="editedPods[i].tariff_code">
                            </app-labeled-input>
                        </div>

                        <div class="w-[300px]">
                            <app-custom-dropdown [options]="priceTypeDropdownOptions"
                                label="{{ 'invoice.labels.price_type' | transloco }}"
                                [(selectedOption)]="editedPods[i].selectedPriceTypeDropdown" [disabled]="saveClicked"
                                boxHeight="min-h-[50px] max-h-[70px]">
                            </app-custom-dropdown>
                        </div>
                    </div>

                    <div class="flex gap-2 flex-wrap items-end mt-4">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.network_tension' | transloco }}"
                                [inputId]="'network_tension_' + i" [inputType]="'text'"
                                [(inputValue)]="editedPods[i].network_tension">
                            </app-labeled-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.tension_factor' | transloco }}"
                                [inputId]="'tension_factor_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].tension_factor">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.power_kw_available' | transloco }}"
                                [inputId]="'power_kw_available_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].power_kw_available">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.power_kw_contracted' | transloco }}"
                                [inputId]="'power_kw_contracted_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].power_kw_contracted">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input
                                labelText="{{ 'invoice.labels.power_kw_max_consumption' | transloco }}"
                                [inputId]="'power_kw_max_consumption_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].power_kw_max_consumption">
                            </app-custom-number-input>
                        </div>
                    </div>

                    <div class="flex gap-2 flex-wrap items-end mt-4">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.dispatch_costs' | transloco }}"
                                [inputId]="'dispatch_costs_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].dispatch_costs">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.dispatching_factor' | transloco }}"
                                [inputId]="'dispatching_factor_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].dispatching_factor">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.market_capacity_p' | transloco }}"
                                [inputId]="'market_capacity_p_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].market_capacity_p">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'shared.labels.electricity.voltage' | transloco }}"
                                [inputId]="'voltage_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].voltage">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'shared.labels.electricity.excise_taxes' | transloco }}"
                                [inputId]="'excise_taxes_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].excise_taxes">
                            </app-custom-number-input>
                        </div>
                    </div>

                    <div class="flex gap-2 flex-wrap items-end mt-4">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.market_capacity_op' | transloco }}"
                                [inputId]="'market_capacity_op_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].market_capacity_op">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.fixed_charge' | transloco }}"
                                [inputId]="'fixed_charge_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].fixed_charge">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.energy_charge_price' | transloco }}"
                                [inputId]="'energy_charge_price_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].energy_charge_price">
                            </app-custom-number-input>
                        </div>
                    </div>

                    <div class="flex gap-2 flex-wrap items-end mt-4">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.power_charge_price' | transloco }}"
                                [inputId]="'power_charge_price_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].power_charge_price">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.reactive_energy_costs' | transloco }}"
                                [inputId]="'reactive_energy_costs_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].reactive_energy_costs">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.fixed_costs' | transloco }}"
                                [inputId]="'fixed_costs_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].fixed_costs">
                            </app-custom-number-input>
                        </div>
                    </div>

                    <div class="flex gap-2 flex-wrap items-end mt-4">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.additional_charges' | transloco }}"
                                [inputId]="'additional_charges_' + i" [inputType]="'number'"
                                [(inputValue)]="editedPods[i].additional_charges">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.taxrate_1' | transloco }}" [inputId]="'taxrate_1_' + i"
                                [inputType]="'number'" [(inputValue)]="editedPods[i].taxrate_1">
                            </app-custom-number-input>
                        </div>
                    </div>

                    <div class="flex gap-2 flex-wrap items-end mt-4">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.taxrate_2' | transloco }}" [inputId]="'taxrate_2_' + i"
                                [inputType]="'number'" [(inputValue)]="editedPods[i].taxrate_2">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-custom-number-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'shared.tms' | transloco }}" [inputId]="'tms_charges' + i"
                                [inputType]="'number'" [(inputValue)]="editedPods[i].tms_charges">
                            </app-custom-number-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.tariff_code' | transloco }}" [inputId]="'tariff_code' + i"
                                [inputType]="'text'" [(inputValue)]="editedPods[i].tariff_code">
                            </app-labeled-input>
                        </div>
                    </div>

                    <!-- Supplier data -->
                    <p class="text-sm font-semibold text-secondary my-4">
                        {{ 'invoice.sections.supplier_details' | transloco }}
                    </p>

                    <div class="flex gap-2 flex-wrap items-end mb-6">
                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.supplier_name' | transloco }}"
                                [inputId]="'supplier_name_' + i" [inputType]="'text'"
                                [(inputValue)]="editedPods[i].supplierData.name">
                            </app-labeled-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.vat_id' | transloco }}" [inputId]="'vat_id_' + i"
                                [inputType]="'text'" [(inputValue)]="editedPods[i].supplierData.vat_id">
                            </app-labeled-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.contact_name' | transloco }}"
                                [inputId]="'contact_name_' + i" [inputType]="'text'"
                                [(inputValue)]="editedPods[i].supplierData.contact_name">
                            </app-labeled-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.contact_number' | transloco }}"
                                [inputId]="'contact_number_' + i" [inputType]="'text'"
                                [(inputValue)]="editedPods[i].supplierData.contact_number">
                            </app-labeled-input>
                        </div>

                        <div class="flex-[1] self-center min-w-[250px]">
                            <app-labeled-input boxHeight="min-h-[50px] max-h-[70px]"
                                labelText="{{ 'invoice.labels.email' | transloco }}" [inputId]="'email_' + i"
                                [inputType]="'text'" [(inputValue)]="editedPods[i].supplierData.email">
                            </app-labeled-input>
                        </div>

                        <app-custom-date-input labelText="{{ 'shared.labels.gas.start_of_supply' | transloco }}"
                            inputId="'supplier_start_of_supply_' + i"
                            placeholder="{{ 'shared.placeholders.gas.start_of_supply' | transloco }}"
                            [(dateValue)]="editedPods[i].supplierData.start_of_supply" [errorMessage]="null"
                            [isDisabled]="false" dateFormat="dd/mm/yy" boxHeight="min-h-[50px] max-h-[70px]">
                        </app-custom-date-input>

                        <app-custom-date-input labelText="{{ 'shared.labels.gas.end_of_supply' | transloco }}"
                            inputId="'supplier_end_of_supply_' + i"
                            placeholder="{{ 'shared.placeholders.gas.end_of_supply' | transloco }}"
                            [(dateValue)]="editedPods[i].supplierData.end_of_supply" [errorMessage]="null"
                            [isDisabled]="false" dateFormat="dd/mm/yy" boxHeight="min-h-[50px] max-h-[70px]">
                        </app-custom-date-input>
                    </div>
                </div>
            </div>

            <div *ngIf="dialogErrorMessage" class="text-error text-sm mt-2">
                {{ dialogErrorMessage }}
            </div>

            <div class="flex flex-wrap w-full gap-4 p-6 justify-center">
                <div class="flex-[1] h-[45px] min-w-[150px] max-w-[500px]">
                    <app-custom-button buttonText="{{ 'shared.cancel' | transloco }}" (buttonClick)="closeModal()"
                        backgroundColor="bg-[#FFFFFF]" textColor="text-secondary" borderColor="border-secondary"
                        hoverBackgroundColor="hover:bg-secondary" hoverBorderColor="hover:border-secondary">
                    </app-custom-button>
                </div>

                <div class="flex-[1] h-[45px] min-w-[150px] max-w-[500px]">
                    <app-custom-button buttonText="{{ 'admin.copy' | transloco }}" (buttonClick)="copyJson()"
                        backgroundColor="bg-[#FFFFFF]" textColor="text-primary" borderColor="border-primary"
                        hoverBackgroundColor="hover:bg-primary" hoverBorderColor="hover:border-primary">
                    </app-custom-button>
                </div>

                <div class="flex-[1] h-[45px] min-w-[150px] max-w-[500px]">
                    <app-custom-button buttonText="{{ 'shared.download' | transloco }}" (buttonClick)="downloadJson()"
                        backgroundColor="bg-[#FFFFFF]" textColor="text-neutral" borderColor="border-neutral"
                        hoverBackgroundColor="hover:bg-primary-1500" hoverTextColor="hover:text-black"
                        hoverBorderColor="hover:border-neutral">
                    </app-custom-button>
                </div>

                <div class="flex-[1] h-[45px] min-w-[150px] max-w-[500px]">
                    <app-custom-button buttonText="{{ 'shared.save' | transloco }}" (buttonClick)="saveJson()"
                        backgroundColor="bg-success" textColor="text-neutral" borderColor="border-neutral"
                        hoverBackgroundColor="hover:bg-success-300" hoverTextColor="hover:text-black"
                        hoverBorderColor="hover:border-neutral">
                    </app-custom-button>
                </div>

            </div>
        </div>
    </ng-template>
</p-dialog>